export default "__VITE_ASSET__XhDSox2M__"